import {Tooltip as ReactTooltip} from 'react-tooltip';

import Color from 'color';
import styled, {css} from 'styled-components';

import type {Props} from './types';

import {getColor, ms} from '../../styles';
import {platform} from '../../utils/platform';
import {isDefined} from '../../utils/typecheck';
import {View} from '../View';

export const Tooltip = styled(ReactTooltip)<Pick<Props, 'width' | 'zPosition'>>`
  opacity: 1 !important;
  border-radius: ${ms(8)} !important;
  padding: ${ms(10)} !important;
  box-shadow: 0 ${ms(4)} ${ms(20)}
    ${p => Color(getColor('global3')(p)).alpha(0.16).toString()};

  ${p =>
    isDefined(p.width) &&
    css`
      width: ${ms(p.width)} !important;
    `};

  ${p => {
    switch (p.zPosition) {
      case 'aboveAlert':
        return css`
          z-index: 3002 !important;
        `;
      default:
        return css`
          z-index: 999 !important;
        `;
    }
  }};
`;

type WebProps = Required<Pick<Props, 'webProps'>>['webProps'];

export const RefContainer = styled(View)<{display?: WebProps['display']}>`
  ${() =>
    platform.isWeb &&
    css<{display?: WebProps['display']}>`
      display: ${p =>
        p.display === 'block'
          ? 'block'
          : p.display === 'flex'
            ? 'flex'
            : 'inline-block'};
      cursor: pointer;
      min-width: 0;
    `};
`;
